import * as React from "react";
import { FC, useContext } from "react";
import Svg from "@natera/material/lib/svg";
import ReminderImage from "@assets/svg/icons/renewal-notification.svg";
import { defineMessages, useIntl } from "react-intl";
import { HEAP_EVENTS } from "@app/provider/types";
import { UserContext } from "@app/provider";

import "./renewalBanner.scss";

const messages = defineMessages({
  renewalBannerTitle: {
    id: "renewalBannerTitle",
    defaultMessage: "Your Signatera is up for renewal",
  },
  renewalBannerSubtitle: {
    id: "renewalBannerSubtitle",
    defaultMessage:
      "It's time to discuss re-ordering Signatera with your provider.",
  },
});

export interface RenewalBannerProps {
  openRenewalDialog: () => void;
  isMobilePhlebotomyPage?: boolean;
  limsId?: number;
  orderUidPublic?: string;
}

const RenewalBanner: FC<RenewalBannerProps> = ({
  openRenewalDialog,
  isMobilePhlebotomyPage,
  limsId,
  orderUidPublic,
}) => {
  const intl = useIntl();
  const { uppUser } = useContext(UserContext);

  const openDialog = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    openRenewalDialog();
    heap.track(
      isMobilePhlebotomyPage
        ? HEAP_EVENTS.upp_renewal_mp_signatera_click
        : HEAP_EVENTS.upp_renewal_homepage_signatera_click,
      {
        identity: uppUser?.patientUID,
        lims_clinic_id: limsId,
        public_order_uid: orderUidPublic,
      }
    );
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      openDialog(event);
    }
  };

  return (
    <div
      className="renewalBanner"
      role="button"
      tabIndex={0}
      onClick={openDialog}
      onKeyDown={handleKeyDown}
      aria-label={intl.formatMessage(messages.renewalBannerTitle)}
    >
      <div className="renewalBanner__icon">
        <Svg content={ReminderImage} />
      </div>
      <div className="renewalBanner__text">
        <div
          data-testid="renewal-banner-title"
          className="renewalBanner__title"
        >
          {intl.formatMessage(messages.renewalBannerTitle)}
        </div>
        <div className="renewalBanner__subtitle">
          {intl.formatMessage(messages.renewalBannerSubtitle)}
        </div>
      </div>
    </div>
  );
};

export default RenewalBanner;
